<!-- eslint-disable max-len -->
<template>
  <div class="properties-field-content">
    <!-- Title -->
    <div class="section-field input-field pb-0 border-0">
      <div class="configuration-section">
        <h4 class="configuration-section-title">General</h4>
        <b-form :class="{'error-input' : $v.dataSetup.title.$error}">
          <label> Title </label>
          <j-input
            v-model="dataSetup.title"
            :error-required="$v.dataSetup.title.$error"
            placeholder="Type title for this component"/>
        </b-form>
        <b-form :class="{'error-input' : $v.dataSetup.url.$error}">
          <label> URL </label>
          <j-input
            v-model="dataSetup.url"
            :error-required="$v.dataSetup.url.$error"
            placeholder="https://"/>
        </b-form>

        <div class="warning-message mt-2">
          <img src="@/assets/icon/warning.svg">
          <div class="d-flex flex-column">
            <p class="warning-title">Information</p>
            <p class="warning-text">
              URL must use HTTPS (Hypertext Transfer Protocol Secure)
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => null,
    },
    dataComponent: {
      type: Object,
      default: () => null,
    },
    dataEdit: {
      type: Object,
      default: () => null,
    },
    pagesId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      dataSetup: {
        title: '',
        url: '',
      },
    };
  },

  created() {
    if (this.dataEdit) {
      this.dataSetup.title = this.dataEdit.name;
      this.dataSetup.url = JSON.parse(this.dataEdit.info).url;
    }
  },

  methods: {
    // eslint-disable-next-line consistent-return
    getData() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const data = {
          value_id: '0',
          pages_id: `${this.pagesId}`,
          name: this.dataSetup.title,
          component_master_id: this.dataMaster.id,
          info: JSON.stringify({
            url: this.dataSetup.url,
          }),
        };
        if (this.dataEdit) data.order = this.dataEdit.order;
        return data;
      }
    },
  },

  validations: {
    dataSetup: {
      title: {
        required,
      },
      url: {
        required,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .warning-message {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: rgba(255, 249, 195, 0.31);
    border-radius: 8px;
    margin-bottom: 16px;

    img {
      width: 14px;
      height: 14px;
      margin-right: 12px;
    }
    .warning-title {
      font-family: 'Poppins-Medium';
      font-size: 12px;
      color: #696014;
      margin-bottom: 2px;
    }
    .warning-text {
      font-family: 'Poppins-Regular';
      font-size: 12px;
      color: #696014;
      margin-bottom: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/forms/jEmbedUrlForm.vue